import { Pipe, PipeTransform } from '@angular/core';
import { VideoSuggestion } from './video-suggestions.model';

@Pipe({
  name: 'currentRouteVideos'
})

export class CurrentRouteVideosPipe implements PipeTransform {
  transform(items: Array<VideoSuggestion>): Array<VideoSuggestion> {
    let result = [];

    if (items) {
      result = items.filter(item => item.matchRoute);
    }

    return result;
  }
}
